// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"ed1b54f9c2de01da","5345":"7df570821880a75a"}[chunkId] + ".css";
};